module.exports = __webpack_public_path__ + "img/RevokedE.e5d4f159.png";